import {
    Box,
    CardContent,
    SpeedDial,
    SpeedDialAction,
    Typography,
} from '@mui/material'
import {React, styled} from 'common'
import DanceCardHeader from './DanceCardHeader'
import MediaPlayer from '../Media/Card/MediaPlayer'
import BrokenImageIcon from '@mui/icons-material/BrokenImage'
import VisibilityIcon from '@mui/icons-material/Visibility'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import {green, grey} from '@mui/material/colors'
import ShareIcon from '@mui/icons-material/Share'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

const getRelevantMediaUrl = (dance) => {
    if (dance.media.length > 0) {
        return dance.media[dance.mainMediaIndex].url
    }
    if (dance.songVideoUrl) {
        return dance.songVideoUrl
    } else return null
}

const actions = [
    {
        key: 'whatsapp',
        icon: <WhatsAppIcon sx={{color: green[500]}} />,
        tooltipTitle: 'Share on WhatsApp',
        onClick: (e) => {
            e.stopPropagation()
        },
    },
    {
        key: 'copy',
        icon: <ContentCopyIcon />,
        tooltipTitle: 'Copy to clipboard',
        onClick: (e) => {
            e.stopPropagation()
        },
    },
]

const DanceCardContent = ({
    dance,
    goToDance,
    danceStyle,
    formattedDate,
    t18Dance,
}) => {
    const mediaUrl = getRelevantMediaUrl(dance)

    return (
        <Container onClick={goToDance}>
            <DanceCardHeader dance={dance} />
            {mediaUrl ? (
                <MediaPlayer url={mediaUrl} />
            ) : (
                <NoMediaBox>
                    <BrokenImageIcon color="disabled" style={{fontSize: 80}} />
                    <Text variant="subtitle1" color="textSecondary">
                        {t18Dance('noMedia')}
                    </Text>
                </NoMediaBox>
            )}
            <DanceDetails>
                <Text variant="subtitle2" color="textSecondary">
                    {formattedDate}
                </Text>
                <Text variant="subtitle2" color="textSecondary">
                    {danceStyle}
                </Text>
            </DanceDetails>
            <CardFooter>
                <DialContainer>
                    <StyledSpeedDial
                        ariaLabel="Share options"
                        icon={<ShareIcon />}>
                        {actions.map((action) => (
                            <SpeedDialAction
                                key={action.key}
                                icon={action.icon}
                                tooltipTitle={action.tooltipTitle}
                                onClick={action.onClick}
                                sx={{
                                    bgcolor: grey[300],
                                }}
                            />
                        ))}
                    </StyledSpeedDial>
                </DialContainer>
                <ViewsContainer>
                    <VisibilityIcon />
                    <Text>40</Text>
                </ViewsContainer>
            </CardFooter>
        </Container>
    )
}

export default DanceCardContent

const Container = styled(CardContent)``

const NoMediaBox = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background-color: #e0e0e0;
    border-radius: 8px;
`

const DanceDetails = styled.div`
    margin-top: 15px;
`
const Text = styled(Typography)``
const ViewsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: space-between;
    gap: 10px;
`

const CardFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 40px;
`
const StyledSpeedDial = styled(SpeedDial)`
    position: absolute;
    bottom: 0;
    .MuiFab-root {
        width: 35px;
        height: 35px;
        box-shadow: none;
    }
    .MuiSvgIcon-root {
        font-size: 20px;
    }
`
const DialContainer = styled(Box)`
    transform: translateZ(0px);
    flex-grow: 1;
    height: 35px;
`
